import { render, staticRenderFns } from "./Zhengshuchaxun.vue?vue&type=template&id=0c644841&scoped=true"
import script from "./Zhengshuchaxun.vue?vue&type=script&lang=js"
export * from "./Zhengshuchaxun.vue?vue&type=script&lang=js"
import style0 from "./Zhengshuchaxun.vue?vue&type=style&index=0&id=0c644841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c644841",
  null
  
)

export default component.exports